const MESES = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez"
];
const EMPRESAS = [
  { value: "TODAS", label: "Todas as unidades" },
  { value: "1", label: "FCK S\xE3o Jos\xE9 dos Campos" },
  { value: "2", label: "FCK Contagem" },
  { value: "3", label: "FCK Belo Horizonte" }
];
const ANOS = [2023, 2024, 2025, 2026];
const REGIOES_BRASIL = {
  AC: "Norte",
  AP: "Norte",
  AM: "Norte",
  PA: "Norte",
  RO: "Norte",
  RR: "Norte",
  TO: "Norte",
  AL: "Nordeste",
  BA: "Nordeste",
  CE: "Nordeste",
  MA: "Nordeste",
  PB: "Nordeste",
  PE: "Nordeste",
  PI: "Nordeste",
  RN: "Nordeste",
  SE: "Nordeste",
  DF: "Centro-Oeste",
  GO: "Centro-Oeste",
  MT: "Centro-Oeste",
  MS: "Centro-Oeste",
  ES: "Sudeste",
  MG: "Sudeste",
  RJ: "Sudeste",
  SP: "Sudeste",
  PR: "Sul",
  RS: "Sul",
  SC: "Sul"
};
const CIDADES = {
  MG: ["Belo Horizonte", "Contagem", "Uberl\xE2ndia", "Juiz de Fora", "Montes Claros"],
  SP: ["S\xE3o Paulo", "Campinas", "S\xE3o Jos\xE9 dos Campos", "Ribeir\xE3o Preto"],
  RJ: ["Rio de Janeiro", "Niter\xF3i", "Campos dos Goytacazes"],
  ES: ["Vit\xF3ria", "Serra"],
  PR: ["Curitiba", "Londrina", "Maring\xE1"],
  SC: ["Joinville", "Florian\xF3polis"],
  RS: ["Porto Alegre", "Caxias do Sul"],
  BA: ["Salvador", "Feira de Santana"],
  PE: ["Recife", "Caruaru"],
  CE: ["Fortaleza", "Sobral"],
  GO: ["Goi\xE2nia", "An\xE1polis"],
  DF: ["Bras\xEDlia"],
  MT: ["Cuiab\xE1", "Rondon\xF3polis"],
  MS: ["Campo Grande", "Dourados"],
  PA: ["Bel\xE9m", "Santar\xE9m"],
  AM: ["Manaus"],
  MA: ["S\xE3o Lu\xEDs"],
  PB: ["Jo\xE3o Pessoa"],
  RN: ["Natal"],
  AL: ["Macei\xF3"],
  SE: ["Aracaju"],
  PI: ["Teresina"],
  TO: ["Palmas"],
  RO: ["Porto Velho"],
  AC: ["Rio Branco"],
  AP: ["Macap\xE1"],
  RR: ["Boa Vista"]
};
const VENDEDORES = [
  "Ana Ribeiro",
  "Bruno Tavares",
  "Carla Nogueira",
  "Diego Fontes",
  "Eduarda Lima",
  "Fabio Andrade",
  "Gisele Prado",
  "Henrique Sales"
];
const PAGAMENTOS = [
  "Pix",
  "Cart\xE3o de Cr\xE9dito",
  "Boleto 30/60/90",
  "Transfer\xEAncia",
  "Cart\xE3o de D\xE9bito",
  "Cheque"
];
const PESO_UF = {
  SP: 32,
  MG: 24,
  RJ: 11,
  PR: 6,
  RS: 5.5,
  SC: 4.5,
  BA: 4,
  GO: 3.2,
  PE: 2.6,
  ES: 2.4,
  CE: 2.2,
  DF: 2,
  MT: 1.8,
  MS: 1.4,
  PA: 1.3,
  AM: 1,
  MA: 0.9,
  PB: 0.8,
  RN: 0.8,
  AL: 0.6,
  SE: 0.5,
  PI: 0.5,
  TO: 0.45,
  RO: 0.4,
  AC: 0.2,
  AP: 0.2,
  RR: 0.15
};
function makeRandom(seed) {
  let s = seed >>> 0;
  return () => {
    s = s * 1664525 + 1013904223 >>> 0;
    return s / 4294967296;
  };
}
let cache = null;
function getFaturamentoDataset() {
  if (cache) return cache;
  const rows = [];
  const rand = makeRandom(20260725);
  const ufs = Object.keys(PESO_UF);
  for (const ano of ANOS) {
    const crescimento = 1 + (ano - 2023) * 0.17;
    for (let mes = 1; mes <= 12; mes++) {
      const sazonal = 0.82 + 0.35 * Math.sin((mes - 3) / 12 * Math.PI * 2) + mes / 40;
      for (const uf of ufs) {
        const cidades = CIDADES[uf] ?? [uf];
        const lancamentos = uf === "SP" || uf === "MG" ? 3 : 1;
        for (let i = 0; i < lancamentos; i++) {
          const cidade = cidades[Math.floor(rand() * cidades.length)];
          const base = PESO_UF[uf] * 9e3 * crescimento * sazonal;
          const valorTotal = Math.round(base * (0.6 + rand() * 0.9));
          rows.push({
            ano,
            mes,
            uf,
            cidade,
            regiao: REGIOES_BRASIL[uf],
            vendedor: VENDEDORES[Math.floor(rand() * VENDEDORES.length)],
            formaPagamento: PAGAMENTOS[Math.floor(rand() * PAGAMENTOS.length)],
            empresa: String(1 + Math.floor(rand() * 3)),
            valorTotal,
            pedidos: Math.max(1, Math.round(valorTotal / (1800 + rand() * 2600)))
          });
        }
      }
    }
  }
  cache = rows;
  return rows;
}
function filtrar(rows, f) {
  return rows.filter(
    (r) => r.ano === f.ano && (f.empresa === "TODAS" || r.empresa === f.empresa) && (f.regiao === "TODAS" || r.regiao === f.regiao)
  );
}
function somarPor(rows, chave) {
  const mapa = /* @__PURE__ */ new Map();
  for (const r of rows) {
    const nome = String(r[chave] ?? "N\xE3o informado").trim() || "N\xE3o informado";
    const atual = mapa.get(nome) ?? { name: nome, valor: 0, pedidos: 0 };
    atual.valor += r.valorTotal;
    atual.pedidos += r.pedidos;
    mapa.set(nome, atual);
  }
  return [...mapa.values()].sort((a, b) => b.valor - a.valor);
}
function serieMensal(rows) {
  const meses = MESES.map((m, i) => ({ mes: m, indice: i + 1, valor: 0, pedidos: 0 }));
  for (const r of rows) {
    const alvo = meses[r.mes - 1];
    if (!alvo) continue;
    alvo.valor += r.valorTotal;
    alvo.pedidos += r.pedidos;
  }
  return meses;
}
const formatBRL = (v) => Number(v || 0).toLocaleString("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 0
});
const formatCompact = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e6) return `R$ ${(n / 1e6).toFixed(1)}M`;
  if (Math.abs(n) >= 1e3) return `R$ ${(n / 1e3).toFixed(0)}K`;
  return `R$ ${n.toFixed(0)}`;
};
const formatNumber = (v) => Number(v || 0).toLocaleString("pt-BR");
const formatPercent = (v) => `${v > 0 ? "+" : ""}${v.toFixed(1)}%`;
export {
  ANOS,
  EMPRESAS,
  MESES,
  REGIOES_BRASIL,
  filtrar,
  formatBRL,
  formatCompact,
  formatNumber,
  formatPercent,
  getFaturamentoDataset,
  serieMensal,
  somarPor
};
